import { addHook } from '@viveaesthetics/elemy-shared-core'
import { useRouter as useNextRouter } from 'next/router'

export const useRouter = addHook({
  useRouter: useNextRouter
})
